/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bulk_Delete_Confirm_Artifacts_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} artifact(s)? This action cannot be undone." |
*
* @param {Bulk_Delete_Confirm_Artifacts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bulk_delete_confirm_artifacts_description = /** @type {((inputs: Bulk_Delete_Confirm_Artifacts_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_Delete_Confirm_Artifacts_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bist du sicher, dass du ${i?.count} Artefakt(e) löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} artifact(s)? This action cannot be undone.`)
});